export default __webpack_public_path__ + "static/media/gesture-one-finger-drag.b6f1c3e1.svg";